import { render, staticRenderFns } from "./SectionServices.vue?vue&type=template&id=1e148d7a&scoped=true"
import script from "./SectionServices.vue?vue&type=script&lang=ts"
export * from "./SectionServices.vue?vue&type=script&lang=ts"
import style0 from "./SectionServices.vue?vue&type=style&index=0&id=1e148d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e148d7a",
  null
  
)

export default component.exports